window.__APP_VERSION = __APP_VERSION__;
